// extracted by mini-css-extract-plugin
export var serverError = "UpdatePaymentForm-module__serverError___yrUKS";
export var divider = "UpdatePaymentForm-module__divider___jyBi5";
export var billingText = "UpdatePaymentForm-module__billingText___r6c2a";
export var wrapperContainerClasses = "UpdatePaymentForm-module__wrapperContainerClasses___ehMXi";
export var form = "UpdatePaymentForm-module__form___THOyF";
export var card = "UpdatePaymentForm-module__card___XrZUV";